/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ResetInputs */

const en_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const es_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer`)
};

const fr_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser`)
};

const de_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

const ja_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リセット`)
};

const zh_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置`)
};

const ar_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة تعيين`)
};

const id_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setel Ulang`)
};

const it_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina`)
};

const ru_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить`)
};

const pt_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir`)
};

const ko_reset = /** @type {(inputs: ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초기화`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {ResetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reset = /** @type {((inputs?: ResetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ResetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reset(inputs)
	if (locale === "es") return es_reset(inputs)
	if (locale === "fr") return fr_reset(inputs)
	if (locale === "de") return de_reset(inputs)
	if (locale === "ja") return ja_reset(inputs)
	if (locale === "zh") return zh_reset(inputs)
	if (locale === "ar") return ar_reset(inputs)
	if (locale === "id") return id_reset(inputs)
	if (locale === "it") return it_reset(inputs)
	if (locale === "ru") return ru_reset(inputs)
	if (locale === "pt") return pt_reset(inputs)
	return ko_reset(inputs)
});